export function setReport(reportName) {
    return {
        type: 'report-set',
        reportName: reportName
    };
}

